import { render, staticRenderFns } from "./SelectorTypeAndStatus.vue?vue&type=template&id=dec47376&"
import script from "./SelectorTypeAndStatus.vue?vue&type=script&lang=ts&"
export * from "./SelectorTypeAndStatus.vue?vue&type=script&lang=ts&"
import style0 from "./SelectorTypeAndStatus.vue?vue&type=style&index=0&id=dec47376&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports